import React, { memo } from 'react';
import styled from '@emotion/styled';
import { space } from 'styled-system';

import type { SpaceProps } from '../../theme/system-types';
import type { NextStep } from '../../types/next-steps';
import Item from './Item';
import { getIsStepActive } from './utils';

interface ListProps {
  id: string;
  items: NextStep[];
}

const Ul = styled.ul<SpaceProps>`
  ${space};
`;

const List = ({ id, items }: ListProps) => (
  <Ul id={id} data-testid="list" m="sp_0" p="sp_0" pt="sp_16">
    {items.map((step, index, array) => (
      <Item
        {...step}
        key={step.label}
        isFirst={index === 0}
        isLast={index === array.length - 1}
        isActive={getIsStepActive(array, index)}
        isNextCompleted={!!array[index + 1] && array[index + 1].isCompleted}
      />
    ))}
  </Ul>
);

export default memo(List);
